import axios from 'axios';
import Cookies from 'js-cookie';

// axios.defaults.withCredentials = true;

axios.interceptors.request.use(function (config) {
    const token = Cookies.get('token');

    // if we have an auth token, add it to the headers
    if(token && token.length) {
        config.headers['X-AUTH-TOKEN'] = token;
    }

    // if xdebug get param is present, add it to the request url
    const xdebugMatch = window.location.href.match(/(XDEBUG_SESSION_START=\d+)/);
    if(xdebugMatch) {
        config.url = config.url.indexOf('?') > -1 ? `${config.url}&${xdebugMatch[1]}` : `${config.url}?${xdebugMatch[1]}`;
    }

    return config;
});

export default axios;

//
// export function addCsrfTokenInterceptor(token) {
//     axios.interceptors.request.use(function (config) {
//         config.withCredentials = true;
//     });
// }
